import React, { Component } from 'react';

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"

class Categorias extends Component {
    constructor() {
        super();
        this.state = { };
    }

    render() {
        const buttons = [
            {
                create: true,
                permission: 'saldos_categorias_add',
                component: Create,
            },
            {
                detail: true,
                permission: 'saldos_categorias_detail',
                component: Detail,
            },
            {
                edit: true,
                permission: 'saldos_categorias_edit',
                component: Edit,
            },
            {
                edit: true,
                permission: 'saldos_categorias_delete',
                component: Delete,
            }
        ]

        const columns = [
            {
                Header: "id",
                id: "pk",
                accessor: "pk",
                width: 100,
                show: false,
                private: true,
            },
            {
                Header: "Nombre",
                id: "nombre",
                accessor: "nombre",
                show: true,
            },
        ]

        return (
            <ParadigmaTable
                buttons={buttons}
                apiUrl={api.saldos.categorias.list}
                columns={columns}
                exportUrl={api.saldos.categorias.export}
                title={"Categorias"}
            />
        );
    }
}

export default Categorias;



// WEBPACK FOOTER //
// ./src/views/Saldos/Categorias/Categorias.js